import Vue from 'vue'
import VueI18n from "vue-i18n"

Vue.use(VueI18n)

import fr from '@/locales/fr'
import en from '@/locales/en'

export default new VueI18n({
  locale: 'fr',
  messages: {
    fr, en
  },
  fallbackLocale: 'fr'
})